module.exports = __webpack_public_path__ + "static/img/weather_010.324c36a4.svg";